import React from 'react';
import ModuleError from 'app/components/districtModulesCommon/ModuleError';
import { SkeletonPlaceholderOverlay, SkeletonPlaceholderWrapper } from 'app/styles/districtModules/SkeletonPlaceholderStyles';
import LoadingSkeleton from 'app/components/competitionModule/LoadingSkeleton';
import { ModuleWrapper } from 'app/components/competitionModule/common/styles';
export default function CompetitionModuleError(_ref) {
  let {
    errorData
  } = _ref;
  const handleClick = () => {
    window.location.reload();
  };
  return /*#__PURE__*/React.createElement(ModuleWrapper, {
    "data-sentry-element": "ModuleWrapper",
    "data-sentry-component": "CompetitionModuleError",
    "data-sentry-source-file": "CompetitionModuleError.tsx"
  }, /*#__PURE__*/React.createElement(SkeletonPlaceholderWrapper, {
    "data-sentry-element": "SkeletonPlaceholderWrapper",
    "data-sentry-source-file": "CompetitionModuleError.tsx"
  }, /*#__PURE__*/React.createElement(SkeletonPlaceholderOverlay, {
    "data-sentry-element": "SkeletonPlaceholderOverlay",
    "data-sentry-source-file": "CompetitionModuleError.tsx"
  }, /*#__PURE__*/React.createElement(ModuleError, {
    id: errorData.getHttpStatusId(),
    onClick: handleClick,
    text: "Die Wettbewerbe f\xFCr diese Region konnten nicht geladen werden. Bitte versuche es erneut.",
    "data-sentry-element": "ModuleError",
    "data-sentry-source-file": "CompetitionModuleError.tsx"
  })), /*#__PURE__*/React.createElement(LoadingSkeleton, {
    animation: false,
    "data-sentry-element": "LoadingSkeleton",
    "data-sentry-source-file": "CompetitionModuleError.tsx"
  })));
}